import { WebsocketProvider } from 'y-websocket';
import { LocalCollaborationProvider } from './LocalCollaborationProvider';
/**
 * Like the local provider (the document is loaded from and saved to the note), but additionally connected
 * to the collaboration relay, which exchanges changes and cursors live with other people editing the note.
 * The relay only forwards the document, notes are still saved through Standard Notes sync.
 */
export class RelayCollaborationProvider extends LocalCollaborationProvider {
    constructor(doc, initialState, relayUrl, room, getToken) {
        var _a;
        super(doc, initialState);
        this.getToken = getToken;
        this.websocket = new WebsocketProvider(relayUrl, room, doc, {
            connect: false,
            disableBc: true,
            maxBackoffTime: 30000,
            params: { token: (_a = getToken()) !== null && _a !== void 0 ? _a : '' },
        });
        /** y-protocols awareness, typed more loosely than Lexical's user state */
        this.awareness = this.websocket.awareness;
        this.websocket.on('status', ({ status }) => {
            var _a;
            if (status === 'disconnected') {
                /** the session token may have been refreshed meanwhile; used for the next connection attempt */
                this.websocket.params = { token: (_a = this.getToken()) !== null && _a !== void 0 ? _a : '' };
            }
            this.emit('status', { status });
        });
    }
    connect() {
        /** the note's own state is loaded first, so the editor works also when the relay is unreachable */
        super.connect();
        this.websocket.connect();
    }
    disconnect() {
        this.websocket.disconnect();
    }
    destroy() {
        this.websocket.destroy();
        this.websocket.awareness.destroy();
    }
}
